import netsGravatar from './nets-gravatar';

export default angular
  .module('app.gravatar', [])
  .component('netsGravatar', netsGravatar);
